import React from "react";
import { Container } from "react-bootstrap";

import HeaderAfterLogin from "../../../../containers/HeaderAfterLogin";
import BackIcon from "../../../../assets/svg/BackIcon";

import Header from "../../../../containers/Header";

import Offer2Banner from "../../../../assets/images/banner/banner2.png"
import { useNavigate } from "react-router-dom";

const Offer2 = ({ isAuth }) => {
  const navigate = useNavigate();
  
  return (
    <>
      {isAuth ? <HeaderAfterLogin /> : <Header />}

      <main className="main" id="profile_page">
        <Container>
          <div className="pagesHeading">
            <h2 className="sectionTitle border-0">Offer 2</h2>
           <div className="back-link" onClick={() => navigate(-1)}>
              Back <BackIcon />
            </div>
          </div>


          <div className="PromotionContentSection">
            <div className="PromtoionBanner">
              <img src={Offer2Banner} alt="offer" />
            </div>
            <div className="PromtoionContent">
              <h4>5% 2nd deposit bonus upto INR 2,000</h4>
              <p>🤑 Jump in and play smart – the thrill never stops once you start!</p>
              <table className="table">
                <thead>
                  <tr>
                    <th> Game Offers</th>
                    <th>Details</th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <th>🎮 Games Included</th>
                    <td>All</td>
                  </tr>
                  <tr>
                    <th> 💰 Minimum Deposit</th>
                    <td>INR 100</td>
                  </tr>
                  <tr>
                    <th>💰 Maximum Bonus Amount</th>
                    <td>INR 2,000</td>
                  </tr>
                  <tr>
                    <th>🎯 Bonus Ratio (%)</th>
                    <td>5%</td>
                  </tr>
                </tbody>
              </table>

              <div className="Terms">
                <h4>Terms & Conditions</h4>
                <p>
                  * The promotion is available only for second-time depositors.
                </p>
                <p>* The Bonus is given in form of coins under bonus wallet.</p>
                <p>
                  * This bonus/coins can be used only in ezugi, evolution and world casino games.
                </p>
                <p>
                  * Multiple accounts will not be considered for this promotion. All players will be subject to duplicate checking. Winfix reserves the right to disqualify players if collusion or any foul play takes place in the promotion.
                </p>
                <p>* Winfix General Terms & Conditions apply.</p>
              </div>
            </div>
            
          </div>
         
         
        </Container>
      </main>
    </>
  );
};

export default Offer2;
